import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const usersTableTooltips = TOOLTIPS_TEXTS.usersTable;

export const BASE_USERS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  /*{ action: 'welcomeEmail', src: 'icons/mail' },*/
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_USERS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_USERS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'email', 'phone', 'jobTitle', 'division', 'role', 'options'],
  displayedTitles: [
    'Name',
    'Email / Username',
    'Mobile Phone',
    'Job Title',
    'Division(s)',
    'Access Level',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    usersTableTooltips.userName,
    usersTableTooltips.email,
    usersTableTooltips.mobilePhone,
    usersTableTooltips.jobTitle,
    usersTableTooltips.division,
    usersTableTooltips.role
  ],
  options: null,
  dataSource: []
};
